
    <fieldmagic-primary-button
      purpose="ai"
      [isInProgress]="generating$ | async"
      (click)="onGenerate()"
    >
    </fieldmagic-primary-button>
  